import { removeCookie } from 'src/utils/cookies';
export const jwtDecode = (token: string) => {
  if (token) {
    return JSON.parse(atob(token.split('.')[1]));
  } else {
    // moving the user to logout screen, as the token is not valid
    removeCookie('user');
    localStorage.clear();
    window.location.href = '/login';
    localStorage.setItem('chatbotLastOpened', new Date().toDateString());
  }
};
